import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

type ApiConnectorProps = {
	children: JSX.Element;
};

export const ApiConnector: React.FC<React.PropsWithChildren<ApiConnectorProps>> = ({ children }) => {
	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
